import React, { FormEventHandler, useState, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import useEmailValidation from "lib/useEmailValidation";
import useFunnyEmailPlaceholder from "lib/useFunnyEmailPlaceholder";

import Input from "./form/Input";
import Submit from "./form/Submit";

import styles from "./SendDownloadLink.module.css";

const SendDownloadLink: React.FC = () => {
  const [emailPlaceholder] = useFunnyEmailPlaceholder();
  const [email, setEmail] = useState("");
  const [inputError, setInputError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [hasValidEmail] = useEmailValidation(email);

  const nodeRef = useRef(null);

  const sendDownloadLink: FormEventHandler = async (event) => {
    event.preventDefault();

    if (!hasValidEmail) {
      setInputError("Email Address is invalid");
      return;
    }

    setInputError("");
    setIsSubmitting(true);

    const response = await fetch("https://api.raycast.app/v2/signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_RAYCAST_API_TOKEN}`,
      },
      body: JSON.stringify({ email, subscriptions: ["download"] }),
    });

    if (response.ok) {
      setIsSubmitting(false);
      setEmail("");
      setSuccessMsg("You're all set, watch your inbox!");

      setTimeout(() => setSuccessMsg(""), 5000);
    }
  };

  return (
    <form className={styles.emailForm} onSubmit={sendDownloadLink}>
      <Input
        placeholder={emailPlaceholder}
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        error={inputError}
      />
      <Submit value="Send download link" disabled={isSubmitting} />
      <CSSTransition
        in={!!successMsg}
        nodeRef={nodeRef}
        timeout={300}
        classNames={{
          enter: styles.transitionEnter,
          enterActive: styles.transitionEnterActive,
          exit: styles.transitionExit,
          exitActive: styles.transitionExitActive,
        }}
      >
        <div ref={nodeRef} className={styles.successMsg}>
          {successMsg}
        </div>
      </CSSTransition>
    </form>
  );
};

export default SendDownloadLink;
